import { combineReducers } from 'redux'
import treeReducer from './tree'
import componentsReducer from './components'
import sessionReducer from './session'
import commonReducer from './commom'

import { setPanes } from './panesConfig'
import material from './material'
import baseData from './baseData'

export default combineReducers({
  tree: treeReducer,
  panes: setPanes,
  components: componentsReducer,
  userMsg: sessionReducer,
  common: commonReducer,
  material,
  baseData,
})
